import { createSelector } from 'reselect';

const selectAddresses = state => state.profile.addresses;
const selectDocuments = state => state.profile.documents;
const selectCountries = state => state.statics.countries;
const selectDocumentTypes = state => state.statics.documentTypes;

export const selectAddressView = createSelector(
  selectAddresses,
  selectCountries,
  (addresses, countries) =>
    addresses
      .filter(a => !a.isDeleted)
      .map(aa => ({
        ...aa,
        country: countries.find(c => c.id === aa.countryId) || {},
      }))
);

export const selectDocumentsView = createSelector(
  selectDocuments,
  selectCountries,
  selectDocumentTypes,
  (documents, countries, documentTypes) =>
    documents
      .filter(a => !a.isDeleted)
      .map(aa => ({
        ...aa,
        country: countries.find(c => c.id === aa.countryId) || {},
        documentType: documentTypes.find(c => c.id === aa.documentTypeId) || {},
      }))
);
